<template>
  <div>
    <b-container fluid class="px-5">
      <div class="mt-4 d-flex justify-content-between">
          <back-arrow title="Ajouter un aliment"/>
      </div>

      <b-card class="mt-2 mb-4 shadow-sm">

        <b-form @submit.stop.prevent="onSubmit">

          <b-form-group
            id="name-input"
            label="Nom *"
            label-for="name-input"
            class="bold-label"
            :invalid-feedback="form.name.invalidFeedback"
            :state="form.name.state"
          >
            <b-form-input
              id="name-input"
              v-model="form.name.value"
              type="text"
              maxlength="250"
              :state="form.name.state"
              required
            ></b-form-input>
          </b-form-group>

          <species-selection
            :families="families"
            :speciess="speciess"
            @didChangeSelectedSpeciess="didChangeSelectedSpeciess"
          />

          <div class="d-flex justify-content-end">
            <b-button type="submit" variant="secondary" :disabled="sendButtonDisabled">Valider</b-button>
          </div>
        </b-form>

      </b-card>
    </b-container>
  </div>
</template>

<script>

import api from '../../services/api';
import BackArrow from "../../components/BackArrow";
import SpeciesSelection from "../species/SpeciesSelection";

export default {

  name: 'FoodCreate',

  components: {
    BackArrow,
    SpeciesSelection
  },

  data() {
    return {
      sendButtonDisabled: false,
      families: [],
      speciess: [],
      autocompleteUnities:[],

      form: {
        name: {
          state: null,
          invalidFeedback: null,
          value: null
        },
        speciess: {
          value: []
        }
      }
    }
  },

  mounted () {
    this.fetchFamilies()
    this.fetchSpecies()
  },

  methods: {

    fetchFamilies() {
      api
        .get(`/family`)
        .then(response => {
          this.families = response.data
        })
    },

    fetchSpecies() {
      api
        .get(`/species`)
        .then(response => {
          this.speciess = response.data
        })
    },

    didChangeSelectedSpeciess(selectedSpeciess) {
      this.form.speciess.value = selectedSpeciess
    },

    onSubmit() {

      this.sendButtonDisabled = true

      let data = new FormData()
      data.append('name', this.form.name.value)
      data.append('speciess', JSON.stringify(this.form.speciess.value))

      api({
        method: 'POST',
        url: 'food',
        data: data
      })
        .then((response) => {
          this.$router.push({
            name: 'FoodIndex'
          }, () => {
            this.$nextTick(() => {
              this.successToast(this.form.name.value)
            })
          })
        })
        .catch((error) => {
          this.sendButtonDisabled = false
          if (error.response.status === 418) {
            const invalidField = error.response.data.invalidField
            this.form[invalidField]["state"] = false
            this.form[invalidField]["invalidFeedback"] = error.response.data.message
          }
        });
    },

    successToast(foodName) {
      this.$bvToast.toast(`Aliment \"${foodName}\" ajouté`, {
        autoHideDelay: 2000,
        toaster: 'b-toaster-bottom-right',
        noCloseButton: true
      })
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/food/FoodCreate.vue